import { createFileRoute } from "@tanstack/react-router"
import NumberWithHoverPoints from "@/components/NumberWithHoverPoint"
import {
  getWalletTransactionExtraById,
  updateWalletTransactionExtra,
} from "@/queries/walletTransactionExtra"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { LoadingSpinner } from "@/components/ui/loading"
import { useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import { useMutation, useQuery } from "@tanstack/react-query"
import { toast } from "sonner"
import { useRouter, useCanGoBack } from '@tanstack/react-router'

export const Route = createFileRoute("/wallet/extra/$id")({
  component: EditWalletTransaction,
})

function EditWalletTransaction() {
  const { id } = Route.useParams()
  const navigate = Route.useNavigate()
  const canGoBack = useCanGoBack()
  const router = useRouter()
  const [value, setValue] = useState(0)

  const hform = useForm({
    values: {
      taken_value: "0",
    },
  })

  const updateTransaction = useMutation({
    mutationFn: (taken_value: any) =>
      updateWalletTransactionExtra(id, { taken_value }),
    mutationKey: ["update", "walletExtra", id],
    onSuccess() {
      toast.success("مبلغ دریافتی با موفقیت بروزرسانی شد")
      router.history.back()
    },
    onError(e) {
      console.log(e)
      toast.error("خطایی در بروزرسانی مبلغ دریافتی رخ داده است")
    },
  })

  const getWalletExtra = useQuery({
    queryFn: () => getWalletTransactionExtraById(id || 0),
    queryKey: ["get", "wallet", "transaction", id],
  })

  useEffect(() => {
    if (!getWalletExtra.isFetching) {
      console.log(getWalletExtra.data?.data)
      const { taken_value, value } = getWalletExtra.data?.data.data
      hform.setValue("taken_value", Intl.NumberFormat().format(taken_value))
      setValue(value)
    }
  }, [getWalletExtra.data])

  const onSubmit = (values: { taken_value: string }) => {
    updateTransaction.mutate(Number(values.taken_value.replaceAll(',', '')))
  }

  return (
    <>
      <Card>
        <div className="flex justify-between items-center">
          <CardHeader>
            <CardTitle>ویرایش مبلغ دریافتی از مشتری</CardTitle>
          </CardHeader>
          <Button
            className="m-4"
            onClick={() => canGoBack ? router.history.back() : navigate({ to: "/wallet/extra" })}
          >
            بازگشت
          </Button>
        </div>

        <CardContent>
          {getWalletExtra.isFetching ? (
            <div className="flex text-center">
              <LoadingSpinner />
            </div>
          ) : (
            <Form {...hform}>
              <form
                onSubmit={hform.handleSubmit(onSubmit)}
                className="space-y-4"
              >
                <p className="font-bold">
                  مقدار با سود :{" "}
                  <NumberWithHoverPoints number={String(value)} />
                </p>
                <FormField
                  name="taken_value"
                  control={hform.control}
                  rules={{
                    min: {
                      value: value,
                      message: `مقدار دریافتی از مشتری باید بیشتر از ${value} مقدار با سود باشد`,
                    },
                  }}
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>مقدار دریافتی از مشتری</FormLabel>
                      <FormControl>
                        <Input
                          dir="ltr"
                          value={field.value}
                          onBlur={field.onBlur}
                          onChange={(e) => {

                            console.log(e.target.value)
                            let p: any =  e.target.value.replaceAll(",", "").replace('NaN', '0')
                            const formated = Intl.NumberFormat().format(p)
                            field.onChange({ target: { value: formated } })
                          }}
                        />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <Button type="submit" isLoading={updateTransaction.isPending}>
                  بروزرسانی
                </Button>
              </form>
            </Form>
          )}
        </CardContent>
      </Card>
    </>
  )
}
